export default "__VITE_ASSET__BJD_mQK$__"